import axiosInstance from "./AxiosConfig";
import endpoints from "./endpoints";

export const authService = {
  login: (credentials) =>
    axiosInstance.post(endpoints.tokenLessEndPoints.login, credentials),

  register: (userData) =>
    axiosInstance.post(endpoints.tokenLessEndPoints.addUser, userData),

  checkUser: (userData) =>
    axiosInstance.post(endpoints.tokenLessEndPoints.findByEmail, userData),

  userInfo: (id) =>
    axiosInstance.get(`${endpoints.tokenEndPoints.userInfo}/${id}`),

  userEdit: (id, data) =>
    axiosInstance.patch(`${endpoints.tokenEndPoints.userEdit}/${id}`, data),

  sendOtp: (data) =>
    axiosInstance.post(`${endpoints.tokenEndPoints.sendOtp}`, data),

  verifyOtp: (data) =>
    axiosInstance.post(`${endpoints.tokenEndPoints.verifyOtp}`, data),

  saveTempUser: (data) =>
    axiosInstance.post(`${endpoints.tokenEndPoints.savetempuser}`, data),

  resetPassword: (data) =>
    axiosInstance.post(`${endpoints.tokenEndPoints.resetPassword}`, data),

  authUser: (data) =>
    axiosInstance.post(endpoints.tokenLessEndPoints.auth, data),
};
